import { render, staticRenderFns } from "./EvalQuestion.vue?vue&type=template&id=e1bd8d84&scoped=true&"
import script from "./EvalQuestion.vue?vue&type=script&lang=js&"
export * from "./EvalQuestion.vue?vue&type=script&lang=js&"
import style0 from "./EvalQuestion.vue?vue&type=style&index=0&id=e1bd8d84&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e1bd8d84",
  null
  
)

export default component.exports